import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { OrderIcon } from '../atoms/Icons';
var AdminNewOrderButton = function (_a) {
    var offerList = _a.offerList;
    var navigate = useNavigate();
    var t = useTranslation().t;
    var handleClickNewOrder = React.useCallback(function () {
        if (!offerList)
            return;
        navigate("/admin/offer_lists/".concat(offerList.id, "/new_order"));
    }, [navigate, offerList]);
    if (!offerList ||
        offerList.fixed ||
        ['draft', 'preparing', 'prepared'].includes(offerList.status))
        return null;
    return (React.createElement(IconButton, { onClick: handleClickNewOrder, size: "large" },
        React.createElement(Tooltip, { title: t('pages.adminOrder.title') || '' },
            React.createElement(OrderIcon, null))));
};
export default AdminNewOrderButton;
